import PropTypes from 'prop-types';
import React from 'react';

import Formaters from '../../formatters';

function Percent({ value, locales }) {
    const formatter = Formaters.getPercentFormatter(locales);
    return (
        <span className="format-percent" data-value={value}>
            {formatter.format(value)}
        </span>
    );
}

Percent.propTypes = {
    value: PropTypes.number.isRequired,
    locales: PropTypes.string,
};
Percent.defaultProps = {
    locales: 'en-us',
};

export default Percent;
